<template>
  <div class="orderAfterSale">
    <div class="top">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="售后中" name="first">
          <div class="sub-main">
            <AftersaleList @handleCurrentChange="handleCurrentChange" v-if="listShow" :afterSaleList="afterSaleList" :total="total" :page="page"></AftersaleList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已完成" name="second">
          <div class="sub-main">
            <AftersaleList @handleCurrentChange="handleCurrentChange" v-if="listShow" :afterSaleList="afterSaleList" :total="total" :page="page"></AftersaleList>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {listSearchMixin} from '../../../config/mixin'
import AftersaleList from '../../../components/base/aftersaleList'
export default {
  name: 'orderAfterSale',
  mixins: [listSearchMixin],
  components: {
    AftersaleList
  },
  data () {
    return {
      afterSaleList: null,
      activeName: 'first',
      keyword: '',
      page: 1,
      total: 0,
      state: -1,
      listShow: false
    }
  },
  mounted () {
    this.getAfterSaleList()
  },
  methods: {
    // 获取售后列表
    getAfterSaleList () {

      const rLoading = this.openLoading()
      let self = this
      if(self.state==1){
        self.state=-1
      }
      if(self.state==2){
        self.state=-2
      }
      let params = {
        url:  api.getOrderListPage + `?search=${self.keyword}&type=${self.state}&page=${self.page}&limit=5`,
        method: 'GET'
      }
      this.sendReq(params, (res) => {
        if (res.success) {
          this.afterSaleList = res.data.list
          this.total = res.data.total
          this.listShow = true
          rLoading.close()
        } else {
                this.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
      })
    },
    // 切换列表
    handleClick (event) {
      this.state = Number(event.index) + 1
      this.page = 1
      this.getAfterSaleList()
    },
    // 分页器跳转
    handleCurrentChange (val) {
      this.page = val
      this.getAfterSaleList()
    }
  }
}
</script>
<style lang="scss" scoped>
.orderAfterSale{
  width: 100%;
  .top{
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    position: relative;
    >>>.el-tabs{
      .el-tabs__header{
        border: 1px solid #E5E5E5;
        margin-bottom: 30px;
        height: 56px;
      }
      .el-tabs__nav{
        margin-left: 20px;
        height: 56px;
      }
      .el-tabs__item{
        height: 56px;
        line-height: 56px;
      }
      .el-tabs__nav-wrap::after{
        height: 0;
      }
    }
    >>>.search{
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      position: absolute;
      height: 56px;
      display: flex;
      align-items: center;
      top: 0;
      right: 0;
      .el-input{
        flex: 3;
        border-radius: 0;
        .el-input__inner{
          border-radius: 0;
        }
        .el-input-group__append{
          border-radius: 0;
          border-left: 0;
          .el-button{
            border-left: 0;
          }
        }
      }
      .el-select{
        flex: 1;
        border-radius: 0;
        height: 40px;
      }
    }
  }
}
.sub-main{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/orderAfterSale/orderAfterSale.vue